import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcEnd = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m12 18-1.425-1.4 3.6-3.6H2v-2h12.175L10.6 7.4 12 6l6 6-6 6ZM20 18V6h2v12h-2Z" })
});
export default SvgIcEnd;
